import styled from 'styled-components'
import Button from '~/components/Buttons/Button'
import { HeightClass } from '~/utils/enum/classes'
import { CSSProperties } from 'react'

export const HeaderRightArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: right;
  gap: 8px;
`

export const ToggleButton = styled(Button)<{
  arrowIconSize: HeightClass
  disabled: boolean
}>`
  padding: 0;
  background-color: transparent;

  && {
    border: none;
  }

  ${({ theme, arrowIconSize }) => `
    width: ${theme.icon.sizes[arrowIconSize]}px;
    height: ${theme.icon.sizes[arrowIconSize]}px;
  `};

  ${({ disabled }) =>
    disabled &&
    `
    cursor: default;
  `}
`

export const getAreaLineStyles = (isCardOpen: boolean): CSSProperties => {
  return {
    borderRadius: isCardOpen ? '7px 7px 0 0' : '7px'
  }
}
